import React from 'react'
import "./Home.css";
import Navbar from "../Navbar/Navbar";
import {Ai_hero,people,google,dropbox,shopify,atlassians,slack} from "../../constants"
function Home() {
  return (
    <div className='App_home' id="Home">
      <div className="App_home_container">
        <Navbar />

        <div className="Home_banner-container">
          <div className="Home_banner-left">
            <h1 className="intro_title">
              Let's Build Something amazing with GPT-3 OpenAI
            </h1>

            <p className="intro-para">
              Yet bed any
              for travelling assistance indulgence unpleasing.Not thoughts all exercise blessing.Indulgence way everything joy alteration boisterous the attachment.Party we years to order allow asked of .
            </p>

            <form>
              <div className="input">
                <input type="email" placeholder='Your Email Address' />
                <input type="submit" value="Get Started" />
              </div>
            </form>

            <div className="users">
              <img src={people} alt="users" />
              <p className = "users_desc"> 1, 600 people requested access a visit in last 24 hours </p>
            </div>
          </div>
          
          <div className="Home_banner-right">
            <img src={Ai_hero} alt="banner" />
          </div>
          
        </div>

        <div className="Sponsors">
          <img src={google} alt="googlelogo" />
          <img src={slack} alt="googlelogo" />
          <img src={atlassians} alt="googlelogo" />
          <img src={dropbox} alt="googlelogo" />
          <img src={shopify} alt="googlelogo" />
        </div>
      </div>
    </div>
  )
}

export default Home